var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"cartaz-preview desempenho-cartaz-page",class:{
    'is-preview-only': _vm.previewOnly,
    'is-embedded': _vm.embedded,
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }